import { LightingModeType, type Maybe, TransactionState } from "types";
import { AppState } from "types/mainTypes";

export type ConvergenceInput = {
	appState: AppState;
	hasTransaction: boolean;
	transactionState: Maybe<TransactionState>;
	openDetailDishTypeId: string | null;
	allergens: string[];
	filteredDishTypeIds: readonly string[];
};

export type DesiredFridgeLighting =
	| { kind: "be-authoritative" }
	| { kind: "fe-driven"; mode: LightingModeType; spotlightDishTypeIds: readonly string[] };

// Precedence: Finished > (IDLE && !hasTransaction) > allergen-filter > detail-open > default Active.
export const computeDesiredLighting = (input: ConvergenceInput): DesiredFridgeLighting => {
	const { transactionState, appState, hasTransaction, allergens, filteredDishTypeIds, openDetailDishTypeId } = input;

	if (transactionState === TransactionState.Finished) {
		return { kind: "be-authoritative" };
	}

	if (appState === AppState.IDLE && !hasTransaction) {
		return { kind: "fe-driven", mode: LightingModeType.StandBy, spotlightDishTypeIds: [] };
	}

	if (allergens.length > 0 && transactionState !== TransactionState.StockCheck) {
		if (openDetailDishTypeId !== null && filteredDishTypeIds.includes(openDetailDishTypeId)) {
			return {
				kind: "fe-driven",
				mode: LightingModeType.Active,
				spotlightDishTypeIds: [openDetailDishTypeId],
			};
		}

		return {
			kind: "fe-driven",
			mode: LightingModeType.Active,
			spotlightDishTypeIds: filteredDishTypeIds,
		};
	}

	if (openDetailDishTypeId !== null) {
		return {
			kind: "fe-driven",
			mode: LightingModeType.Active,
			spotlightDishTypeIds: [openDetailDishTypeId],
		};
	}

	return { kind: "fe-driven", mode: LightingModeType.Active, spotlightDishTypeIds: [] };
};
